import React from 'react'
import Fotter from '../../../Home/Home_modules/Footerr/Footer_main'
import Creater from '../Middle/Creater'
import Loran_title from '../Middle/Loran_title'
import More_nft from '../Middle/More_nft'
import Video from '../TOP/Video'
import firebaseConfig from '../../../fire';


function NFT_Final_full() {

    firebaseConfig.auth().onAuthStateChanged(function(user) {

        if(user) {
           //Here you can place the code that you want to run if the user is logged in
        } else {
           window.location.href = "../login";
        }
        
        });
  

    return (
        <div>
            <Video/>
            <Loran_title/>
            <Creater/>
            <More_nft/>
            <Fotter/>
        </div>
    )
}



export default NFT_Final_full
